import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

class FreespinSymbolSubstituteSupplement implements DataProcessorSupplement {

    public substitutions: Map<string, string> = new Map<string, string>();

    /**
     * Substitutes symbols during freespins
     *
     * @param record {Record}
     */
    public process(record: Record) {
        if (record && record instanceof FreespinRecord) {
            if (record.grid) {
                for (const reel of record.grid) {
                    for (let y = 0; y < reel.length; y++) {
                        this.substitutions.forEach((substitute: string, symbol: string) => {
                            if (reel[y] === symbol) {
                                reel[y] = substitute;
                            }
                        });
                    }
                }
            }
        }

    }
}

export default new FreespinSymbolSubstituteSupplement();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/supplements/freespin-symbol-substitute-supplement.ts